import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITrap } from '@models/restore-id/trap';


@Injectable()
export class TrapService {
  private _url = 'api/trap';

  constructor(private _httpClient: HttpClient) { }

  async getTraps(locationname: string): Promise<ITrap[]> {
    return new Promise((resolve, reject) => {

      const params = new HttpParams()
      .set('locationname', locationname);

      this._httpClient.get<ITrap[]>(`${this._url}`, { params }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getTrapsByMultipleLocations(locationNames: string[]): Promise<ITrap[]> {
    const params = new HttpParams().set('data', JSON.stringify(locationNames));

    return new Promise((resolve, reject) => {

      this._httpClient.get<ITrap[]>(`${this._url}/multiple-locations`, { params }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getTrapById(id: string): Promise<ITrap> {
    return new Promise((resolve, reject) => {

      this._httpClient.get<ITrap>(`${this._url}/${id}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async createNewTrap(trap: ITrap): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.post<void>(`${this._url}`, trap).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async updateTrap(id: string, updatedData: ITrap): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.put<void>(`${this._url}/${id}`, updatedData).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }

  async deleteTrap(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.delete<void>(`${this._url}/${id}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }

  async importTrap(data: ITrap[]): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.post<void>(`${this._url}/import`, { data }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

}
